import React, { useEffect, useState } from "react";
import style from "./SubTopic.module.css";
import uparrow from "../../../assests/uparrow.svg";
import sidearrow from "../../../assests/sidearrow.svg";
import downarow from "../../../assests/downarrowdown.svg";
import { FaArrowLeftLong } from "react-icons/fa6";
import range from "../../../assests/Rectangle.svg";
import level from "../../../assests/level.svg";
import calendar from "../../../assests/calendar.svg";
import question from "../../../assests/question_icon.png";
import clock from "../../../assests/Clock.svg";
import fav from "../../../assests/favorite_icon.png";
import { baseurl } from "../../Url";
import { useNavigate } from "react-router-dom";
import Loader from "../../Loder/Loader";
import { Alert, Snackbar } from "@mui/material";
import { IoClose } from "react-icons/io5";
import { useSelector } from "react-redux";



const SubTopic = ({
  onBack,
  aiId,
  topicId,
  topicIndex,
  topicValue,
  moduleName,
  moduleIndex,
  searchTerm,
  expandAll,
  showPageHeader = true,
}) => {
  const [expandedSubtopicIds, setExpandedSubtopicIds] = useState(new Set());
  const navigate = useNavigate();
  const { userDetails } = useSelector((state) => state.user);
  const isTrialUser = userDetails?.user_type === "Trail";
  const TRIAL_SKILL_LIMIT = 1;
  const isTrialSkillLocked = (skillIndex) =>
    isTrialUser && skillIndex >= TRIAL_SKILL_LIMIT;
  const toggleExpand = (id) => {
    setExpandedSubtopicIds((prev) => {
      const next = new Set(prev);
      if (next.has(id)) {
        next.delete(id);
      } else {
        next.add(id);
      }
      return next;
    });
  };
  const [selectedSubtopic, setSelectedSubtopic] = useState(null);
  const [subtopicsData, setsubtopicsData] = useState([]);
  const [metaInfo, setMetaInfo] = useState({
    ai_id: "",
    main_topic_id: "",
    topic_id: "",
  });
  const [searchResults, setSearchResults] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [popupText, setPopupText] = useState("");
  const [lastAssessmentData, setLastAssessmentData] = useState(null);
  const [selectedSkill, setSelectedSkill] = useState(null);
  const [snack, setSnack] = useState({ open: false, message: "" });
  const hasActiveSession = Boolean(lastAssessmentData?.session_status);
  const showSnack = (message) => {
    setSnack({ open: true, message });
    setTimeout(() => setSnack({ open: false, message: "" }), 2500);
  };

  const handlePopupNo = () => {
    const hasActiveSession = Boolean(lastAssessmentData?.session_status);
    if (lastAssessmentData?.is_trial_user === true) {
      setShowPopup(false);
      return;
    }
    if (hasActiveSession) {
      navigate("/practice", {
        state: {
          ai_id: metaInfo.ai_id,
          main_topic_id: metaInfo.main_topic_id,
          topic_id: metaInfo.topic_id,
          topic_name: metaInfo.topic_name,
          skill_id: selectedSkill?.skill_id,
          skill_name: selectedSkill?.skill_name,
          value: selectedSkill?.value,
          continue: false,
          page_reload: true,
          subtopic_title: selectedSubtopic?.title,
          subtopic_index: selectedSubtopic?.index,
          uniqueId: selectedSubtopic?.unique_id,
          pageNum: selectedSubtopic?.index + 1,
          title: selectedSubtopic?.title,
          fromSubTopic: true,
          topicIndex,
          topicValue,
          moduleName,
          moduleIndex,
        },
      });
      setShowPopup(false);
    } else {
      setShowPopup(false);
    }
  };

  const handlePopupClose = () => {
    setShowPopup(false);
  };

  const handlePopupYes = () => {
    navigate("/practice", {
      state: {
        ai_id: metaInfo.ai_id,
        main_topic_id: metaInfo.main_topic_id,
        topic_id: metaInfo.topic_id,
        topic_name: metaInfo.topic_name,
        skill_id: selectedSkill?.skill_id,
        skill_name: selectedSkill?.skill_name,
        value: selectedSkill?.value,
        continue: Boolean(lastAssessmentData?.session_status),
        page_reload: true,
        subtopic_title: selectedSubtopic?.title,
        subtopic_index: selectedSubtopic?.index,
        uniqueId: selectedSubtopic?.unique_id,
        pageNum: selectedSubtopic?.index + 1,
        title: selectedSubtopic?.title,
        fromSubTopic: true,
        topicIndex,
        topicValue,
        moduleName,
        moduleIndex,
      },
    });
    setShowPopup(false);
  };

  const fectchsubTopics = async () => {
    const token = localStorage.getItem("access-token");
    const userId = localStorage.getItem("USERID");
    const ORG_id = localStorage.getItem("ORGID");
    if (token) {
      try {
        const requestBody = {
          Organization_ID: ORG_id,
          ai_id: aiId || "",
          user_id: userId,
          topic_id: topicId || aiId || "",
          search: (searchTerm || "").trim(),
        };
        
        console.log("API Request Body:", requestBody);
        console.log("Topic ID from props:", aiId);
        console.log("Topic ID from topicId prop:", topicId);
        
        const response = await fetch(`${baseurl}/details/subtopic-details`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(requestBody),
        });

        console.log("Topic ID from state:", metaInfo.topic_id);
        if (response.ok) {
  const data = await response.json();
  console.log("API Response:", data);

  // Always store full subtopics
  setsubtopicsData(data?.data?.pages || []);

  // Store just the matched skills list
  const flatSearchSkills = (data?.data?.search_results || []).flatMap(sr => sr.selected_skills || []);
  setSearchResults(flatSearchSkills);

  setMetaInfo({
    ai_id: data?.data?.ai_id || aiId || "",
    main_topic_id: data?.data?.main_topic_id || "",
    topic_id: data?.data?.topic_id || "",
    topic_name: data?.data?.topic_name || "",
  });
}
      } catch (error) {
        console.error("Error fetching Ai ID:", error);
      }
    }
  };

  useEffect(() => {
    fectchsubTopics();
  }, [searchTerm]);
  

  const assessementpendingCheck = async (skillData) => {
    const token = localStorage.getItem("access-token");
    const userId = localStorage.getItem("USERID");
    const ORG_id = localStorage.getItem("ORGID");

    if (token) {
      try {
        const response = await fetch(`${baseurl}/practice/active-session`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            User_ID: userId,
            main_topic_id: metaInfo.main_topic_id,
            topic_id: metaInfo.topic_id,
            ai_id: aiId,
            mapped_skills: [
              {
                label: skillData.skill_name,
                skill_id: skillData.skill_id,
                skill_name: skillData.skill_name,
                value: skillData.skill_id,
              },
            ],
          }),
        });

        if (response.ok) {
          const data = await response.json();
          console.log(data);
          return data;
        }
      } catch (error) {
        console.error("Error fetching Ai ID:", error);
        throw error;
      }
    }
  };
      
  const handleSkillClick = async (skill,subtopic,index, skillIndex) => {
    if (skill?.can_attend === false) {
      showSnack("subscribe for attend more practice test");
      return;
    }
    if (isTrialSkillLocked(skillIndex)) return;
    try {
      if (!aiId) {
        showSnack("You need to complete the module lesson first");
        return;
      }

      const skillData = {
        skill_id: skill?.skill_id || skill?.value || "",
        skill_name: skill?.skill_name || skill?.label || "",
        value: skill?.value || skill?.skill_id || "",
      };

      // Call assessementpendingCheck first
      const assessmentData = await assessementpendingCheck(skillData);

      // Store for next actions and show popup based on session_status
      setSelectedSkill(skillData);
      setLastAssessmentData(assessmentData);
      setSelectedSubtopic({ title: subtopic?.title, index: index, unique_id: subtopic?.unique_id });
      const hasActiveSession = Boolean(assessmentData?.session_status);
      setPopupText(
        hasActiveSession
          ? "Do you want to resume your last skills practice session?"
          : "Are you sure you want to start a practice session?"
      );
      setShowPopup(true);
    } catch (error) {
      console.error("Error in assessment check:", error);
      // You can handle error cases here if needed
    }
  };
 useEffect(() => {
  if (!subtopicsData.length) return;

  if (expandAll) {
    const allIds = new Set(subtopicsData.map(sub => sub.unique_id));
    setExpandedSubtopicIds(allIds);
  } else {
    setExpandedSubtopicIds(new Set());
  }
}, [expandAll, subtopicsData]);

  return (
    <div className={style.Conatiner}>
      <div className={style.SubConatiner}>
        {showPageHeader && (
          <div className={style.HeaderCard}>
            <div className={style.HeaderContainer}>
              <div className={style.headWrapper}>
                <div className={style.iconContainer} onClick={onBack}>
                  <FaArrowLeftLong />
                </div>
                <div className={style.headwrapp}>
                  <p>Module {moduleIndex || 0}</p>
                  <p>Topic {topicIndex || 0}</p>
                </div>
              </div>

              <div className={style.ParaContainer}>
                <p>{moduleName || ""}</p>
                <p>{topicValue || ""}</p>
              </div>
            </div>
          </div>
        )}

        
   {/* If searching */}
{(searchTerm || "").trim() ? (
  searchResults && searchResults.length > 0 ? (
    subtopicsData.map((subtopic, i) => {
      const filteredSkills = (subtopic?.selected_skills || []).filter(skill =>
        searchResults.some(
          res => res.skill_id === skill.skill_id || res.value === skill.value
        )
      );

      if (filteredSkills.length === 0) return null;

      return (
        <div className={style.moduleCard} key={subtopic?.unique_id || i}>
          {/* Subtopic Header */}
          <div className={style.moduleCardTop}>
            <div className={style.moduleCardName}>
              <p>SubTopic {i + 1}</p>
            </div>
          </div>
          <div className={style.moduleCardBottomLeft}>
            <p>{subtopic?.title}</p>
          </div>

          {/* Auto-expanded design */}
          <div className={style.topicContainer}>
            {filteredSkills.map((skill, idx) => {
  const originalIndex = (subtopic?.selected_skills || []).findIndex(
    (s) =>
      (s.skill_id || s.value) === (skill.skill_id || skill.value)
  );
  const skillIndex = originalIndex >= 0 ? originalIndex : idx;
  const isLocked = isTrialSkillLocked(skillIndex);
  const hasLastAttended =
    skill?.last_attended !== undefined && skill?.last_attended !== null;

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  };

  const formatTime = (seconds) => {
    const hrs = Math.floor(seconds / 3600);
    const mins = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;
    
    if (hrs > 0) {
      return `${hrs}:${mins.toString().padStart(2, '0')}:${secs
        .toString()
        .padStart(2, '0')}`;
    } else {
      return `${mins}:${secs.toString().padStart(2, '0')}`;
    }
  };

  const calculateProficiency = (score, threshold) => {
    if (!threshold) return 0;
    const percentage = (score / threshold) * 100;
    return Math.min(Math.floor(percentage / 20), 5);
  };

  const proficiencyLevel = calculateProficiency(
    skill?.total_mark_scored || 0,
    skill?.threshold_marks || 0
  );
  const percentage= skill?.threshold_marks ? Math.min(100,Math.round((skill?.total_mark_scored / skill?.threshold_marks) * 100)) : 0;
  return (
    <div
      key={skill?.skill_id || skill?.value || idx}
      className={`${style.topicCard}
    ${
      hasLastAttended
        ? (percentage > 85
            ? style.greenComplete   
            : percentage > 40
              ? style.yellowCard   
              : style.redCard)      
        : style.complete            
    }
    ${isLocked ? style.disabledCard : ""}
  `}
      onClick={() => handleSkillClick(skill, subtopic, i, skillIndex)}
    >
      <div className={style.wholeWrapper}>
        <div className={style.skillWrapp}>
          <p>Skill {idx + 1}</p>
        </div>
        <div className={style.mainContainer}>
          <p className={style.understandPara}>
            {skill?.label || skill?.skill_name || "Untitled Skill"}
          </p>

          {hasLastAttended && (
            <div className={style.detailsWrapper}>
              <div className={style.MiniWrapper}>
                <div className={style.proWrapper}>
                  <p>Practice Level</p> <img src={level} alt="" />
                </div>
                <div className={style.rangeContainer}>
                  {[...Array(5)].map((_, p) => (
                    <img
                      key={p}
                      src={range}
                      alt=""
                      style={{ opacity: p < proficiencyLevel ? 1 : 0.3 }}
                    />
                  ))}
                </div>
              </div>

              <div className={style.MiniWrapper}>
                <div className={style.proWrapper}>
                  <p>Last Practiced</p> <img src={calendar} alt="" />
                </div>
                <div className={style.DateContainer}>
                  <p>{formatDate(skill?.last_attended)}</p>
                </div>
              </div>

              <div className={style.MiniWrapper}>
                <div className={style.proWrapper}>
                  <p>Answered</p> <img src={question} alt="" />
                </div>
                <div className={style.DateContainer}>
                  <p>{skill?.questions_attended || 0}</p>
                </div>
              </div>

              <div className={style.MiniWrapper}>
                <div className={style.proWrapper}>
                  <p>Time Spent</p> <img src={clock} alt="" />
                </div>
                <div className={style.DateContainer}>
                  <p>{formatTime(skill?.total_time_taken)}</p>
                </div>
              </div>

              <div className={style.MiniWrapper}>
                <div className={style.proWrapper}>
                  <p>Proficiency</p> <img src={fav} alt="" />
                </div>
                <div className={style.DateContainer}>
                  <p>
                    {percentage} %
                  </p>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
})}


          </div>
        </div>
      );
    })
  ) : (
    <p style={{ color: "red", padding: "0.5rem 1rem" }}>
      No matching skills found
    </p>
  )
) : (
  subtopicsData.length > 0 ? (
    subtopicsData.map((subtopic, i) => (
      <div
        className={style.moduleCard}
        key={subtopic?.unique_id || i}
        onClick={() => toggleExpand(subtopic?.unique_id || i)}
      >
        {/* Top Section */}
        <div className={style.moduleCardTop}>
          <div className={style.moduleCardName}>
            {/* <p>SubTopic {i + 1}</p> */}
          </div>
        </div>

        {/* Bottom Section */}
        <div className={style.moduleCardBottom}>
          <div className={style.moduleCardBottomLeft}>
            <p>{subtopic?.title}</p>
          </div>
          <div className={style.moduleCardBottomRight}>
            {expandedSubtopicIds.has(subtopic?.unique_id || i) ? (
              <img
                src={uparrow}
                alt=""
                onClick={(e) => {
                  e.stopPropagation();
                  toggleExpand(subtopic?.unique_id || i);
                }}
              />
            ) : (
              <img
                src={downarow}
                alt=""
                onClick={(e) => {
                  e.stopPropagation();
                  toggleExpand(subtopic?.unique_id || i);
                }}
              />
            )}
          </div>
        </div>

        {/* Expandable Topics */}
        {expandedSubtopicIds.has(subtopic?.unique_id || i) && (
          <div className={style.topicContainer}>
            {(subtopic?.selected_skills || []).length === 0 ? (
              <p style={{ color: "red" }}>No skills mapped yet</p>
            ) : (
              (subtopic?.selected_skills || []).map((skill, idx) => {
                 const hasLastAttended = skill?.last_attended !== undefined && skill?.last_attended !== null;
                 const isLocked = isTrialSkillLocked(idx);

                      if (!hasLastAttended) {
                        return (
                          <div
                            key={skill?.skill_id || skill?.value || idx}
                            className={`${style.topicCard} ${style.complete} ${isLocked ? style.disabledCard : ""}`}
                            onClick={() => handleSkillClick(skill,subtopic,i, idx)}
                          >
                            <div className={style.topicCardparaWrapper}>
                              <p className={style.topicP1}>Skill {idx + 1}</p>
                              <p className={style.topicHead}>
                                {skill?.label ||
                                  skill?.skill_name ||
                                  skill?.value ||
                                  "Untitled Skill"}
                              </p>
                            </div>
                          </div>
                        );
                      }

                      const formatDate = (dateString) => {
                        const date = new Date(dateString);
                        return date.toLocaleDateString("en-GB", {
                          day: "2-digit",
                          month: "2-digit",
                          year: "numeric",
                        });
                      };

                      const formatTime = (seconds) => {
                        const hrs = Math.floor(seconds / 3600);
                        const mins = Math.floor((seconds % 3600) / 60);
                        const secs = seconds % 60;
                                            
                        if (hrs > 0) {
                          return `${hrs}:${mins.toString().padStart(2, '0')}:${secs
                            .toString()
                            .padStart(2, '0')}`;
                        } else {
                          return `${mins}:${secs.toString().padStart(2, '0')}`;
                        }
                      };

                      const calculateProficiency = (score, threshold) => {
                        if (!threshold) return 0;
                        const percentage = (score / threshold) * 100;
                        return Math.min(Math.floor(percentage / 20), 5);
                      };

                      const proficiencyLevel = calculateProficiency(
                        skill?.total_mark_scored || 0,
                        skill?.threshold_marks || 0
                      );
                      const percentage= skill?.threshold_marks ? Math.min(100,Math.round((skill?.total_mark_scored / skill?.threshold_marks) * 100)) : 0;

                      return (
                        <div
                          key={skill?.skill_id || skill?.value || idx}
                          className={`${
                            hasLastAttended
                              ? (percentage > 85
                                  ? style.greenComplete   
                                  : percentage > 40
                                    ? style.yellowCard   
                                    : style.redCard)      
                              : style.complete            
                          } ${isLocked ? style.disabledCard : ""}`}
                          onClick={() => handleSkillClick(skill,subtopic,i, idx)}
                        >
                          <div className={style.wholeWrapper}>
                            <div className={style.skillWrapp}>
                              <p>Skill {idx + 1}</p>
                            </div>
                            <div className={style.mainContainer}>
                              <p className={style.understandPara}>
                                {skill?.label || skill?.skill_name}
                              </p>
                              <div className={style.detailsWrapper}>
                                <div className={style.MiniWrapper}>
                                  <div className={style.proWrapper}>
                                    <p>Practice Level</p> <img src={level} alt="" />
                                  </div>
                                  <div className={style.rangeContainer}>
                                    {[...Array(5)].map((_, p) => (
                                      <img
                                        key={p}
                                        src={range}
                                        alt=""
                                        style={{ opacity: p < proficiencyLevel ? 1 : 0.3 }}
                                      />
                                    ))}
                                  </div>
                                </div>
                                <div className={style.MiniWrapper}>
                                  <div className={style.proWrapper}>
                                    <p>Last Practiced</p> <img src={calendar} alt="" />
                                  </div>
                                  <div className={style.DateContainer}>
                                    <p>{formatDate(skill?.last_attended)}</p>
                                  </div>
                                </div>
                                <div className={style.MiniWrapper}>
                                  <div className={style.proWrapper}>
                                    <p>Answered</p> <img src={question} alt="" />
                                  </div>
                                  <div className={style.DateContainer}>
                                    <p>{skill?.questions_attended || 0}</p>
                                  </div>
                                </div>
                                <div className={style.MiniWrapper}>
                                  <div className={style.proWrapper}>
                                    <p>Time Spent</p> <img src={clock} alt="" />
                                  </div>
                                  <div className={style.DateContainer}>
                                    <p>{formatTime(skill?.total_time_taken)}</p>
                                  </div>
                                </div>
                                <div className={style.MiniWrapper}>
                                  <div className={style.proficiencyData}>
                                    <div className={style.proWrapper}>
                                    <p>Proficiency</p> <img src={fav} alt="" />
                                  </div>
                                  <div className={style.DateContainer}>
                                    <p>
                                      {percentage} %
                                    </p>
                                  </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      );               
              })
            )}
          </div>
        )}
      </div>
    ))
  ) : (
    <Loader />
  )
)}

      </div>

      {showPopup && (
        <>
          <div className={style.popupOverlay}></div>
          <div className={style.Popup}>
            {hasActiveSession && (
              <button
                type="button"
                className={style.popupCloseButton}
                onClick={handlePopupClose}
                aria-label="Close"
              >
                <IoClose />
              </button>
            )}
            <div className={style.popupText}>
              <p style={{textAlign:"center"}}>{popupText}</p>
              {hasActiveSession && (
        <div><span>
            You paused your exercises on</span>
            <div className={style.subtopicTitle}>{selectedSubtopic?.title}</div>
          </div>
        )}
            </div>
            <div className={style.PopupButton}>
              <button className={style.noButton} onClick={handlePopupNo}>
                {hasActiveSession
                  ? lastAssessmentData?.is_trial_user === true
                    ? "Cancel"
                    : "No, start again please"
                  : "No"}
              </button>
              <button className={style.yesButton} onClick={handlePopupYes}>
                {hasActiveSession ? "Yes" : "Yes"}
              </button>
            </div>
          </div>
        </>
      )}

      <Snackbar
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        open={snack.open}
        sx={{ width: "25rem" }}
        autoHideDuration={3000}
        onClose={() => setSnack({ open: false, message: "" })}
      >
        <Alert
          severity="warning"
          variant="filled"
          sx={{ width: "100%", fontSize: "1rem" }}
        >
          {snack.message || ""}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default SubTopic;
